import { useState } from "react"
import { DropdownProps } from "./Dropdown.types"
import DownIcon from "../../media/DownIcon"
import "./Dropdown.css"
import useClickOutside from "../../hooks/useClickOutside"

/**
 * Dropdown is responsible for rendering a dropdown menu with selectable options.
 * 
 * @param {string}   label for the dropdown
 * @param {string[]} dropdowns options
 * @param {number}   selected index of the selected dropdown item
 * @param {Function} onClick callback function called when a dropdown option is clicked
 */
const Dropdown = (props: DropdownProps) => {

  const { dropdown, isLoading } = props
  const [showDropdowns, setShowDropdowns] = useState<boolean>(false)
  const [{ contextRef }] = useClickOutside({onClickOutside: () => setShowDropdowns(false)})

  return (
    !isLoading ? (
      <div className="dropdown-container" ref={contextRef}>
        <div className="dropdown-options-container" onClick={() => setShowDropdowns(!showDropdowns)}>
          <div className="dropdown-options-flex-container">
            <p>{dropdown.values[dropdown.selected]}</p>
            <DownIcon />
          </div>

          {showDropdowns && (
            <div className="dropdown-options">
              {dropdown.values.map((value, key) =>(
                <p className="dropdown-option" key={key} onClick={() => dropdown.onChange(key)}>{value}</p>
              ))}
            </div>
          )}
        </div>
      </div>
    ) : (
      <div className="loading-dropdown"></div>
    )
  )
}

Dropdown.defaultTypes = {
  isLoading: false
}

export default Dropdown